import {
	ClarificationImpact,
	ClarificationStatus,
} from "../types/clarification.type";

export const CLARIFICATION_STATUS_LABELS: Record<ClarificationStatus, string> =
	{
		[ClarificationStatus.draft]: "Draft",
		[ClarificationStatus.open]: "Open",
		[ClarificationStatus.closed]: "Closed",
		[ClarificationStatus.pending]: "Pending",
	};

export const CLARIFICATION_STATUS_COLORS: Record<ClarificationStatus, string> =
	{
		[ClarificationStatus.draft]: "bg-blue-100 text-blue-700",
		[ClarificationStatus.open]: "bg-green-100 text-green-700",
		[ClarificationStatus.closed]: "bg-gray-100 text-gray-700",
		[ClarificationStatus.pending]: "bg-yellow-100 text-yellow-700",
	};

// RFx statuses that allow viewing clarifications (evaluation phase and beyond)
export const CLARIFICATION_VISIBLE_STATUSES = [
	"EVALUATION",
	"AWARDED",
	"COMPLETE",
	"UNSUCCESSFUL",
] as const;

export const CLARIFICATION_IMPACT = {
	FINANCIAL: "financial",
	SCOPE: "scope",
	SCHEDULE: "schedule",
	TECHNICAL: "technical",
	NONE: "none",
} as const;

export const CLARIFICATION_IMPACT_LABELS: Record<ClarificationImpact, string> =
	{
		[ClarificationImpact.financial]: "Financial",
		[ClarificationImpact.scope]: "Scope",
		[ClarificationImpact.schedule]: "Schedule",
		[ClarificationImpact.technical]: "Technical",
		[ClarificationImpact.none]: "None",
	};

export const CLARIFICATION_IMPACT_COLORS: Record<ClarificationImpact, string> =
	{
		[ClarificationImpact.financial]: "bg-blue-100 text-blue-700",
		[ClarificationImpact.scope]: "bg-green-100 text-green-700",
		[ClarificationImpact.schedule]: "bg-orange-100 text-orange-700",
		[ClarificationImpact.technical]: "bg-yellow-100 text-yellow-700",
		[ClarificationImpact.none]: "bg-gray-100 text-gray-700",
	};
